export const Nav = () => {
  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-50 border-b border-[#1e293b]/70 bg-[#090d12]/80 backdrop-blur-md"
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
        <a
          href="#hero"
          data-testid="nav-logo"
          className="flex items-center gap-2.5 font-mono text-sm font-semibold uppercase tracking-wider text-white"
        >
          <svg
            className="h-6 w-6 text-[#22d3ee]"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M4 17l6-6-6-6" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 19h8" strokeLinecap="round" />
          </svg>
          <span>
            runloft<span className="text-[#22d3ee]">.dev</span>
          </span>
        </a>
        <div className="flex items-center gap-6 font-mono text-xs uppercase tracking-widest text-[#94a3b8]">
          <a href="#features" data-testid="nav-specs-link" className="hidden transition-colors hover:text-white sm:inline">
            Specs
          </a>
          <a href="#pricing" data-testid="nav-pricing-link" className="hidden transition-colors hover:text-white sm:inline">
            Pricing
          </a>
          <a href="#faq" data-testid="nav-faq-link" className="hidden transition-colors hover:text-white sm:inline">
            FAQ
          </a>
          <a
            href="#waitlist"
            data-testid="nav-join-waitlist-button"
            className="rounded border border-[#22d3ee]/40 bg-[#22d3ee]/10 px-3.5 py-1.5 font-medium text-[#22d3ee] transition-colors hover:bg-[#22d3ee] hover:text-[#090d12]"
          >
            Join Waitlist
          </a>
        </div>
      </div>
    </nav>
  );
};
